import { GetServerSideProps } from 'next';
import { ComponentProps } from 'react';
import { z } from 'zod';
import cms from '../../lib/contentful';
import { BlogExcerpt } from '../../src/components/BlogArchive';
import BlogPage, { BlogPageArchiveData } from '../../src/components/BlogPage';
import Navbar from '../../src/components/Navbar';
import { BLOG_POSTS_PAGINATION_PAGE_SIZE } from '../../src/Config';
import { CFImage } from '../../lib/types';

export type BlogIndexPageProps = {
  postSummaries: Array<BlogExcerpt>
  totalPages: string
  blogLogo: CFImage
  currentPage: string
  navbarData: ComponentProps<typeof Navbar>
  totalPosts: number
  blogPageArchive: BlogPageArchiveData
  categories: {[key: string]: number}
}

const BlogIndexPage = ({
  postSummaries, currentPage, totalPosts, blogPageArchive, navbarData, categories,
} : BlogIndexPageProps) => (
  <BlogPage
    categories={categories}
    blogPageArchive={blogPageArchive}
    blogExcerpts={postSummaries}
    totalPosts={totalPosts}
    currentPage={currentPage}
    navbarData={navbarData}
    postSummaries={postSummaries}
  />
);

export const blogQuerySchema = z.object({
  category: z.array(
    z.string(),
  ).or(z.string())
    .transform((val) => (
      (Array.isArray(val) ? val : [val]).filter(Boolean))).default([]),
  page: z.coerce.number().default(1),
  q: z.string().default(''),
});

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { category: categories, page, q: search } = await blogQuerySchema.parseAsync(ctx.query);
  const totalPosts = await cms.getTotalNumberOfBlogPosts(categories, search);
  const blogPageArchive = await cms.getBlogPageArchive();
  const totalPages = Math.ceil(totalPosts.numberOfPosts / BLOG_POSTS_PAGINATION_PAGE_SIZE);
  const navbarData = await cms.getNavbar();
  const postSummaries = await cms.getPaginatedBlogPostsEntries(page, categories, search);
  return {
    props: {
      postSummaries: postSummaries.blogPost,
      totalPages,
      currentPage: page,
      navbarData: navbarData.menu,
      totalPosts: totalPosts.numberOfPosts,
      categories: totalPosts.categories,
      blogPageArchive,
    },
  };
};

export default BlogIndexPage;
